import React, { Component } from "react";
import {
  Row,
  Col,
  Progress,
  Card,
  CardBody,
  CardHeader,
  Table,
  Form,
  FormGroup,
  Label,
  Button,
  Input
} from "reactstrap";
import AuthService from "../../components/AuthService";
import { ToastContainer, toast } from "react-toastify";
import XLSX from "xlsx";

class Tags extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.state = {
      uploadedTags: [],
      nbTagMax: 5,
      usersTags: {}
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.insertUserTag = this.insertUserTag.bind(this);
  }

  //  pour l'affichage des messages d'erreurs
  notifyError(err) {
    toast.error(err);
  }

  //  pour l'affichage des messages de success
  notifySuccess(msg) {
    toast.success(msg);
  }

  //  pour l'affichage des messages d'erreurs
  notifyInfo(err) {
    toast.info(err);
  }

  componentDidMount() {
    this.fetchTags(this);
  }

  // récuperation des tags
  fetchTags(thus) {
    this.setState({
      isLoading: true
    });
    this.Auth.httpRequest("GET", "api/dashboard/selectUsersAndTags").then(
      function (datas) {
        thus.setState((state, props) => {
          return { usersTags: datas.data };
        });
      }
    );
  }

  // Action lorsqu'on a cliquer sur le submit
  // Préparation du tableau formater pour passer la requete à l'API
  handleSubmit(event) {
    var bodyRequest = new Array();

    //  préparer l'objet bodyRequest
    this.state.uploadedTags.forEach(
      function (emailTags) {
        for (var i = 0; i < this.state.nbTagMax; i++) {
          var tagIncrement = "tag";
          var tuple = new Object();
          tagIncrement += i;

          if (emailTags[tagIncrement]) {
            tuple["email"] = emailTags["email"];
            tuple["tag"] = emailTags[tagIncrement];

            bodyRequest.push(tuple);
          }
        }
      }.bind(this)
    );

    //console.log("Le body request final est le suivant : ",bodyRequest);
    this.insertUserTag(bodyRequest);
  }

  //Fonction qui lance la requete pour inserer les tags dans la BD
  insertUserTag(bodyRequest) {
    //  on défini l'état en chargement
    this.setState({
      isLoading: true
    });


    // L'ajout de labels a été réalisé avec succès pour xx utilisateurs
    // xx emails n'ont pas encore créé de compte sur Happy Quest

    this.Auth.httpRequest("post", "api/dashboard/insertUsersTags", bodyRequest)
      .then(datas => {
          console.log(datas);
          datas = datas.data;
          var msg = "L'ajout de labels a été réalisé avec succès pour " + datas.updatedUsers + " utilisateurs.\n\r" + datas.missingUsers  + " emails n'ont pas encore créé de compte sur Happy Quest.\n\r" + ((datas.failedUpdatedUsers > 0) ? "\n\rErreur de mise à jour " + datas.failedUpdatedUsers + "emails." : "") + ((datas.errorGetTagId > 0 ) ? "\n\rErreur de récuperation de label." : "") + ((datas.errorInsertTag > 0 ) ? "\n\rErreur d'insertion de label." : "") + ((datas.errorInsertUserTag > 0 ) ? "\nErreur d'insertion de label associé à un utilisateur" : "");
        this.notifyInfo(msg);
        this.setState({
          isLoading: false
        });
      })
      .catch(error => {
          console.log(error);
        this.notifyError( "Erreur d'insertion des tags, le fichier est mal formaté et/ou un utilisateur indiqué n'existe pas");
      })
      .finally(() => {
        this.fetchTags(this);
      });
  }

  // Permet de telecharger le fichier, de le parser et de le transformer en .json
  handleFile(e) {
    try {
      var rABS = true;
      var files = e.target.files;
      var f = files[0];
      var reader = new FileReader();

      // On prépare les headers qui permmettent de transformer le xlsx en json
      var headers = new Array();
      headers.push("email");
      for (var i = 0; i < this.state.nbTagMax; i++) {
        var tagIncrement = "tag";
        tagIncrement += i;
        headers.push(tagIncrement);
      }

      //on lit dans le fichier
      reader.onload = function (e) {
        var data = e.target.result;
        if (!rABS) data = new Uint8Array(data);
        var workbook = XLSX.read(data, { type: rABS ? "binary" : "array" });

        //On converti le fichier xlsx en json
        var tab = XLSX.utils.sheet_to_json(
          workbook.Sheets[workbook.SheetNames[0]],
          { header: headers }
        );

    //  on supprime la 1ère ligne automatiquement, elle nous intéresse pas
        tab.shift();

        this.setState({ uploadedTags: tab });
      }.bind(this);

      if (rABS) {
        reader.readAsBinaryString(f);
      }
    } catch (error) {
      this.notifyError(error);
    }
  }

  render() {
    let content, tabletags, loading;
    /*
    if (this.state.isLoading) {
      loading = <img src="/img/loading_icon.gif" style={{ height: 'auto', width: 'auto', maxWidth: 70 + 'px', maxHeight: 70 + 'px' }} />
    }
    */

    content = (
      <CardBody className="pb-0">
        <ToastContainer />
        <Form onSubmit={this.handleSubmit}>
          <FormGroup row>
            <Label sm={6}>Fichier d'exemple d'utilisateurs et de leur labels associés</Label>
            <Col sm={6}>
              <Button
                onClick={event => {
                  event.preventDefault();
                  window.location = "./static/templateTags.xlsx";
                }}
              >
                Télécharger le modèle
              </Button>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="inputfile" sm={6}>
              Fichier à envoyer (format XLSX)
            </Label>
            <Col sm={6}>
              <Input
                required
                id="inputfile"
                type="file"
                value={this.state.value}
                onChange={this.handleFile}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={6}></Label>
            <Col sm={6}>
              <Button>Importer</Button>
            </Col>
          </FormGroup>
        </Form>
        <br />
      </CardBody>
    );

    tabletags = (
      <Table responsive striped bordered>
        <thead>
          <tr>
            <th>Utilisateur</th>
            <th>Label</th>
          </tr>
        </thead>
        <tbody>
          {this.state.usersTags && this.state.usersTags.length > 0 ? (
            this.state.usersTags.map((object, index) => {
              return (
                <tr key={index}>
                  <td>{object.email}</td>
                  <td>
                    {object.tags.map((t, i) => {
                      return (
                        <Button key={i} color="primary" outline>
                          {t.tag != '' ? (t.tag) : 'Aucun label associé'}
                        </Button>
                      );
                    })}
                  </td>
                </tr>
              );
            })
          ) : (
              <tr>
                <td />
                <td />
              </tr>
            )}
        </tbody>
      </Table>
    );

    return (
      <div className="animated fadeIn">
        <br />
        <Row>
          <Col xs="12" lg="12">
            <Card className="text-white bg-primary">
              <CardHeader>
                <i className="fa fa-align-justify" /> Mise à jour des labels utilisateurs
              </CardHeader>
              {content}
            </Card>
            <Card>
              <CardHeader>
                <i className="fa fa-align-justify" /> Vos utilisateurs et leurs labels
              </CardHeader>
              {tabletags}
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Tags;



// WEBPACK FOOTER //
// ./src/views/Tags/Tags.js